import { useQuery } from "@tanstack/react-query";
import adminApiClient, { ArtistPreviewStats } from "../../api/admin";

export type ArtistPreviewRange =
  | { days: number }
  | { from: string; to: string };

export const useArtistPreviewStats = (range: ArtistPreviewRange) => {
  return useQuery<ArtistPreviewStats>({
    queryKey: ["artistPreviewStats", range],
    queryFn: () => adminApiClient.getArtistPreviewStats(range),
  });
};
